import bridgeV1 from './iosV1'
import bridgeV2 from './iosV2'

const bridge = {
  ...bridgeV1,
  ...bridgeV2
}

export default bridge
